/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./CompanyProfile.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Media_1 = require("./Media");
var ProfilePicture_1 = require("./ProfilePicture");
var Address_1 = require("./Address");
var Icon_1 = require("./Icon");
var PropTypes = require("prop-types");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-companyProfile");
var disabledProfileColor = "#CCD0D6";
var CompanyProfile = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyProfile, _super);
    function CompanyProfile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyProfile.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, color = _b.color, badgeCount = _b.badgeCount, name = _b.name, address = _b.address, selected = _b.selected, validated = _b.validated, locked = _b.locked, mobile = _b.mobile, header = _b.header, props = tslib_1.__rest(_b, ["className", "color", "badgeCount", "name", "address", "selected", "validated", "locked", "mobile", "header"]);
        var isValid = validated === undefined || !!validated;
        var companyProfileColor = isValid && color ? color : disabledProfileColor;
        var abbreviation = locked && isValid ? (React.createElement(Icon_1.Icon, { type: "lock", size: 0.9375 })) : (this.props.abbreviation);
        return (React.createElement(Media_1.Media, tslib_1.__assign({}, props, { className: classnames(moduleClassName(), "m-media-account", (_a = {},
                _a[moduleClassName("disabled")] = !isValid || locked,
                _a[moduleClassName("header")] = !!header,
                _a[moduleClassName("selected")] = !!selected,
                _a), "m-companyProfile-" + (mobile ? "mobile" : "desktop"), className) }),
            React.createElement(Media_1.MediaVisual, null,
                React.createElement(ProfilePicture_1.ProfilePicture, { abbreviation: abbreviation, color: companyProfileColor, badgeCount: badgeCount })),
            React.createElement(Media_1.MediaContent, null,
                React.createElement(Address_1.Address, null,
                    React.createElement("strong", null, name),
                    React.createElement("br", null),
                    React.createElement("em", null, address))),
            this.renderAside()));
    };
    CompanyProfile.prototype.renderAside = function () {
        if (this.props.selected) {
            return (React.createElement(Media_1.MediaAside, null,
                React.createElement(Icon_1.Icon, { type: "check" })));
        }
        return;
    };
    CompanyProfile.propTypes = {
        className: PropTypes.string,
        abbreviation: PropTypes.node.isRequired,
        color: PropTypes.string,
        badgeCount: PropTypes.number,
        name: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired,
        mobile: PropTypes.bool.isRequired,
        validated: PropTypes.bool,
        locked: PropTypes.bool,
        selected: PropTypes.bool,
        header: PropTypes.bool
    };
    return CompanyProfile;
}(React.Component));
exports.CompanyProfile = CompanyProfile;